import { useState, useRef, useEffect, useMemo } from "react";
import Style from "css/header_css/header_d.module.css";
import AlertIcon from "assets/header_assets/alert_icon.svg";
import UserIcon from "assets/header_assets/user_icon.svg";
import MypageIcon from "assets/header_assets/myPage_icon.svg";
import LogoutIcon from "assets/header_assets/logout_icon.svg";
import PointIcon from "assets/header_assets/point_icon.svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useUser } from "util/context/user_context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import BlockUserModal from "components/block_user_dialog";
import NotificationBell from "components/header/notification_bell";

function Header({ isMobile }) {
  const [openDropdown, setOpenDropdown] = useState(false); // 드롭다운 상태
  const dropdownRef = useRef();
  const { setUserData, userData } = useUser();
  const isExpert = userData["userType"] === "수리기사"; // 수리기사인지 확인하는 변수]
  const [blockUserModal, setBlockUserModal] = useState(false); // 차단된 유저 모달 상태

  // 헤더 메뉴 기본
  const links = useMemo(() => {
    if (isExpert) {
      return [
        { id: 1, text: "메인", path: "/expertmain" },
        { id: 2, text: "받은요청", path: "/received" },
        { id: 3, text: "매칭목록", path: "/matching_done" },
        { id: 4, text: "커뮤니티", path: "/community" },
        { id: 5, text: "문의하기", path: "/inquiry" },
      ];
    } else {
      return [
        { id: 1, text: "메인", path: "/main" },
        { id: 2, text: "요청목록", path: "/matching" },
        { id: 3, text: "커뮤니티", path: "/community" },
        { id: 4, text: "문의하기", path: "/inquiry" },
      ];
    }
  }, []);

  useEffect(() => {
    // 드롭다운 바깥클릭시 닫기 위한 용도
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /// 로그아웃
  const logout = async () => {
    try {
      sessionStorage.removeItem("userData"); // 로컬스토리지 초기화
      window.location.replace("/"); // 뒤로가기 방지
    } catch (error) {
      console.log("logout error : ", error);
    }
  };

  return (
    <>
      <div
        className="px-[16px] md:px-[90px] py-[18px]"
        style={{
          position: "relative",
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 1px 2px 0px #0000000D",
          zIndex: 100,
        }}
      >
        {/* 왼쪽 */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "40px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", gap: "36px", alignItems: "center" }}>
              <Link
                to={userData.userType === "수리기사" ? "/expertmain" : "/main"}
                className={Style.f24w700green}
              >
                뚝딱이
              </Link>
              {/* 헤더 메뉴 */}
              {/* 모바일 아닐때만 보이는 메뉴 */}
              {!isMobile && (
                <>
                  {links.map((link) => {
                    const { id, text, path } = link;
                    return (
                      <NavLink
                        key={id}
                        to={path}
                        className={({ isActive }) =>
                          isActive ? Style.f16w700green : Style.f16w400green
                        }
                        style={{ cursor: "pointer", textDecoration: "none" }}
                      >
                        {text}
                      </NavLink>
                    );
                  })}
                </>
              )}
            </div>
            {/* 오른쪽 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <NotificationBell />
              <div
                ref={dropdownRef}
                style={{ position: "relative", cursor: "pointer" }}
                onClick={() => setOpenDropdown(!openDropdown)}
              >
                <img src={UserIcon} style={{ minWidth: "18px" }} />
                {/* 드롭다운 */}
                {openDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "#fff",
                      boxShadow:
                        "0px 10px 15px 0px #0000001A, 0px 4px 6px 0px #0000001A",
                      borderRadius: "8px",
                      width: "192px",
                      overflow: "hidden",
                      zIndex: 100,
                    }}
                  >
                    <div
                      className="flex flex-col"
                      style={{ borderBottom: "1px solid #F3F4F6" }}
                    >
                      <Link
                        className="hover:bg-black/5 transition-all active:bg-black/10"
                        to="/mypage"
                        style={{
                          padding: "10px 12px",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {/* onClick 추가해야함 */}
                        <img src={MypageIcon} />
                        <div style={{ width: "14px" }} />
                        <div className={Style.f16w400black}>마이페이지</div>
                      </Link>
                      <div
                        className={`${Style.f16w400black} hover:bg-black/5 transition-all active:bg-black/10`}
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "center",
                          padding: "10px 12px",
                        }}
                        onClick={() => {
                          setBlockUserModal(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faBan} />
                        <div>차단목록</div>
                      </div>
                      {isExpert && (
                        <Link
                          className="hover:bg-black/5 transition-all active:bg-black/10"
                          to="/addpoint"
                          style={{
                            padding: "10px 12px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <img src={PointIcon} />
                          <div style={{ width: "12px" }} />
                          <div className={Style.f16w400black}>포인트관리</div>
                        </Link>
                      )}
                    </div>

                    {/* 로그아웃 */}
                    <div
                      className="hover:bg-black/5 transition-all active:bg-black/10"
                      style={{
                        padding: "10px 12px",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={logout}
                    >
                      <img src={LogoutIcon} />
                      <div style={{ width: "12px" }} />
                      <div className={Style.f16w400red}>로그아웃</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* 모바일일때만 보이는 메뉴 */}
          {isMobile && (
            <div style={{ display: "flex", gap: "26px" }}>
              <>
                {links.map((link) => {
                  const { id, text, path } = link;
                  return (
                    <NavLink
                      key={id}
                      to={path}
                      className={({ isActive }) =>
                        isActive ? "f14_111827_W500" : "f14_6B7280_W500"
                      }
                      style={{ cursor: "pointer", textDecoration: "none" }}
                    >
                      {text}
                    </NavLink>
                  );
                })}
              </>
            </div>
          )}
        </div>
      </div>
      {blockUserModal && (
        <>
          <BlockUserModal
            isOpen={blockUserModal}
            setIsOpen={setBlockUserModal}
          />
        </>
      )}
    </>
  );
}

export default Header;
